//Promise polyfill
import 'es6-promise/auto';

import * as jQuery from 'jquery';

import {Query as q} from 'typeQuery/query/query';
import { Init } from 'typeQuery/core/init';
import {_App} from 'typeQuery/core/decorators/app.decorator';

import { qSlider } from 'typeQuery/mixins/slider.mixin';

//import main styles

import { qAnimate } from 'typeQuery/mixins/animate.mixin';

import './styles/main.scss';

import { LogoSlider } from './logos-slider';

@_App({
    mixins: [qSlider, qAnimate],
}) 
class App {
    constructor() { }
    onInit() {   
        console.log('te');     
        (<any>$('.slider--promo-big')).slick({
            arrows: false,
            dots: true,
            autoplay: true,
            autoplaySpeed: 3000,
        });
        (<any>$('.quotes-slider')).slick({
            arrows: false,
            dots: false,
            autoplay: true,
            adaptiveHeight: true,
            autoplaySpeed: 5000,
        });
        (<any>$('.slider--works')).slick({
            arrows: false,
            dots: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            autoplay: true,
            autoplaySpeed: 3000,
            responsive: [
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
        (<any>$('.slider--promo-small')).slick({
            vertical: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true,
            dots: false,
            autoplay: true,
            autoplaySpeed: 3000,
            verticalSwiping: true,
            appendArrows: '.slider--promo-small-arrows'
        });
        (<any>$('.slider--often-read')).slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: false,
            dots: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 1300,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                }
            ]
        });

        new LogoSlider('.partners__slider');
        new LogoSlider('.media-partners__slider');

        this.navSearchHandler();
        this.scrollTopHandler();
        this.navMobileHandler();
    }    

    scrollTopHandler() {
        const scrollTopButton = document.querySelector('.arrow-up');
        
        scrollTopButton.addEventListener('click', (e) => {
            e.preventDefault();

            (<any>jQuery)('html, body').animate({scrollTop : 0},800);
        });
    }
    navSearchHandler() {
        const searchInput = document.querySelector('.nav__search'),
            searchForm = document.querySelector('.nav__search-form');

        searchInput.addEventListener('click', (e) => {
            e.preventDefault();

            searchInput.querySelector('span').classList.toggle('fa-times');
            searchForm.classList.toggle('nav__search-form--visible');

                (<HTMLInputElement>searchForm.querySelector('.search-field')).focus();
  
        });
    }

    navMobileHandler() {
        const navInput = document.querySelector('.nav__menu-button button'),
            navMenu = document.querySelector('.nav__menu');

        navInput.addEventListener('click', (e) => {
            e.preventDefault();

            navInput.querySelector('span').classList.toggle('fa-times');
            navInput.querySelector('span').classList.toggle('fa-bars');
            navMenu.classList.toggle('active');
  
        });
    }
}

Init(App);



function initMap() {
    var mapOptions = {
        //52.224501, 21.074601
        center: new google.maps.LatLng(52.220501, 21.074601),
        zoom: 14,
        disableDefaultUI: true,
        scrollwheel: false,
        zoomControl: true,
		styles: [{"featureType":"administrative","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"poi","elementType":"all","stylers":[{"saturation":-100},{"lightness":"50"},{"visibility":"simplified"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"lightness":"30"}]},{"featureType":"road.local","elementType":"all","stylers":[{"lightness":"40"}]},{"featureType":"transit","elementType":"all","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]},{"featureType":"water","elementType":"labels","stylers":[{"lightness":-25},{"saturation":-100}]}]
    }
    var map = new google.maps.Map(document.getElementById("map"), <any>mapOptions);
    var marker = new google.maps.Marker({
        position: new google.maps.LatLng(52.224501, 21.074601),
        map: map,
        title: 'Hello World!',
        icon: 'http://thepoint.com.pl/wp-content/themes/thepoint/assets/images/map-pin.png'
      });
}




// WEBPACK FOOTER //
// ./main.ts